import { ActionWithOptionalPayload } from 'common/store/typings';
import { VALIDATION_WARNING, WarningState } from './type';

export const initialState: WarningState = {
    questionId: -1,
    partyId: -1,
    hasMaximaValidationIssue: false,
};

export const validationWarningReducer = (state: WarningState = initialState, action: ActionWithOptionalPayload): WarningState => {
    switch (action.type) {
    case VALIDATION_WARNING:
        return {
            ...state,
            ...action.payload,
        };
    }
    return state;
};
